<script>
import BarList from '../components/bar-list'
import ItemList from '../forms/item-list'
import TabpreList from '../forms/tabpre-list'
import TabdesList from '../forms/tabdes-list'
import DestaqList from '../forms/destaq-list'
import GruestList from '../forms/gruest-list'
import ItemAjusteEstoque from '../forms/item-ajuste-estoque'
import ItemPrecosList from '../forms/item-precos-list'
import ItemsEstoqueList from '../consultas/consulta-items-estoque'
import GradeList from '../forms/grade-list'
import UnimedList from '../forms/unimed-list'
import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0,
        }
    },

    components: {
        BarList, ItemList, TabpreList, TabdesList, DestaqList, GruestList, ItemPrecosList, ItemsEstoqueList, ItemAjusteEstoque, GradeList, UnimedList
    },

    computed: {
        tabs: function () {
            let tabs = []
            if (!this.usuarioComum) {
                tabs = [
                    { title: 'Produtos', icon: 'fa-archive' },
                    { title: 'Grupos', icon: 'fa-cubes' },
                    { title: 'Grades', icon: 'fa-th' },
                    { title: 'Tabelas Preço', icon: 'fa-dollar'  },
                    { title: 'Tabelas Desconto', icon: 'fa-tag' },
                    { title: 'Tabelas Destaques', icon: 'fa-star' },
                    { title: 'Estoque Atual', icon: 'fa-clipboard', hidden: !SysVars.appForcaVendas },
                    { title: 'Unidade Medida', icon: 'fa-sort-numeric-desc' },
                    { title: 'Pesquisa Preços', icon: 'fa-dollar' },
                    // { title: 'Saldos de Estoque', icon: 'fa-clipboard' },
                ]
            }
            else {
                tabs = [
                    { title: 'Produtos', icon: 'fa-archive' },
                    { title: 'Pesquisa Produtos', icon: 'fa-archive' },
                    { title: 'Estoque Atual', icon: 'fa-clipboard', hidden: !SysVars.appForcaVendas },
                ]
            }
            return tabs
        },

        tabPesquisa: function () {
            if (this.usuarioComum)
                return this.activeTab == 1
            else
                return this.activeTab == 8
        },

        tabProdutos: function () {
            return this.activeTab == 0
            // return this.activeTab == 0 && !this.usuarioComum
        },

        tabGrupos: function () {
            if (!this.usuarioComum)
                return this.activeTab == 1
        },

        tabGrade: function () {
            if (!this.usuarioComum)
                return this.activeTab == 2
        },

        tabPreco: function () {
            if (!this.usuarioComum)
                return this.activeTab == 3
        },

        tabDes: function () {
            if (!this.usuarioComum)
                return this.activeTab == 4
        },

        tabDestaq: function () {
            if (!this.usuarioComum)
                return this.activeTab == 5
        },

        tabUndMedidas: function () {
            if (!this.usuarioComum)
                return this.activeTab == 7
        },

        tabAjusteEstoque: function () {
            if (!this.usuarioComum)
                return this.activeTab == 9
        },

        tabEstoque: function () {
            if (this.usuarioComum)
                return this.activeTab == 2
            else
                return this.activeTab == 6
        },


        usuarioComum: function () {
            return this.$store.getters.getSessao.perfil == '3'
        },

        usuario_logado_uuid: function () {
            return this.$store.getters.getEnv.uuid
        },
    },

    methods: {
        closeForm() {

        },

        changeTab (idx) {
            //mudança de pagina
            console.log(idx)
            this.activeTab = idx
        },

    },

    created () {

    }

}

</script>

<template>
    <div>
        <tabs :tabindex="1" :tabsTextStyle="'font-size: 13px'" :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

        <div class="nb-margin-top">
            <!-- PRODUTOS -->
            <transition v-if="tabProdutos">
                <item-list></item-list>
            </transition>

            <!-- PESQUISA -->
            <transition v-if="tabPesquisa">
                <item-precos-list></item-precos-list>
                <!-- <items-estoque-list></items-estoque-list> -->
            </transition>

            <!-- ESTOQUE -->
            <transition v-if="tabEstoque">
                <items-estoque-list></items-estoque-list>
            </transition>


            <!-- GRUPOS -->
            <transition v-if="tabGrupos">
                <gruest-list></gruest-list>
            </transition>

            <!-- PREÇOS -->
            <transition v-if="tabPreco">
                <tabpre-list></tabpre-list>
            </transition>

            <!-- PREÇOS -->
            <transition v-if="tabDes">
                <tabdes-list></tabdes-list>
            </transition>

            <!-- DESTQUE -->
            <transition v-if="tabDestaq">
                <destaq-list></destaq-list>
            </transition>

            <!-- GRADE -->
            <transition v-if="tabGrade">
                <grade-list></grade-list>
            </transition>

            <transition v-if="tabUndMedidas">
                <unimed-list></unimed-list>
            </transition>

            <transition v-if="tabAjusteEstoque">
                <item-ajuste-estoque></item-ajuste-estoque>
            </transition>

        </div>

    </div>

</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-produtos-menu.vue